import React, { FC } from 'react'
import { CountBadge } from '@contrast-security-inc/design-system-badges'
import {
  IconNotification,
  theme
} from '@contrast-security-inc/design-system-foundations'
import { useNewNotificationsCountQuery } from './api'
import { css } from '@emotion/css'

interface NotificationsTriggerProps {
  onClick: () => void
  getRef: (ref: any) => void
  organizationUuid: string
  isMenuOpen: boolean
}

export const NotificationsTrigger: FC<NotificationsTriggerProps> = ({
  onClick,
  getRef,
  organizationUuid,
  isMenuOpen
}) => {
  const newCount = useNewNotificationsCountQuery({
    organizationUuid,
    isMenuOpen
  })
  return (
    <ul
      className={css`
        float: right;
        padding: 13px 9px 0 16px;
      `}
    >
      <li
        data-testid="notifications-menu-trigger"
        onClick={(event) => {
          event.stopPropagation()
          event.preventDefault()
          onClick()
        }}
        className={css`
          margin-left: 10px;
          padding-right: 0px;
          ::marker {
            /*  Marketing's new "Midnight Blue"  token. TODO - Add this to skeletor */
            color: #0a004f;
          }
        `}
      >
        <div
          className={css`
            cursor: pointer;
            color: ${theme.color.white};
            position: relative;
          `}
        >
          {/* ref is retrieved here so that the notification menu arrow points to the icon */}
          <IconNotification color="white" size="md" ref={getRef} />
          <span
            data-testid="notification-new-count-container"
            className={css`
              position: absolute;
              right: -9px;
              top: -6px;
              visibility: ${newCount === 0 ? 'hidden' : 'visible'};
            `}
          >
            <CountBadge
              data-testid="notification-new-count"
              color="red50"
              borderColor="neutral100"
              count={newCount}
            />
          </span>
        </div>
      </li>
    </ul>
  )
}
